const labelsAndHelpText = {
  browser: {
    protocolSetupForm: {
      lpo: {
        label: "LPO"
      },
      protocolNumber: {
        label: "Protocol",
        helpText: "If you cannot find a Protocol, please contact the CTSU Help Desk."
      },
      formPartType: {
        label: "Form Type"
      },
      validation: {
        required: "Please complete required fields to continue",
        initiate: "Initiate the new protocol request"
      },
      buttons: {
        next: "Next",
        cancel: "Cancel"
      },
      title: "Protocol Setup, OPEN",
      helpText: {
        protocol: "If you cannot find a protocol, please contact the CTSU Help Desk."
      },
      loading: "Loading..."
    },
    gridCustomFilters: {
      leadGrp: {
        label: "leadGrp"
      },
      protocolNumber: {
        label: "protocolNumber"
      }
    },
    requestBrowser: {
      title: "Protocol Setup Request Browser",
      tableTitle: "Request Browser",
      subtitle: "OPEN/Rave Setup forms initiate the development of a new protocol in OPEN and Rave or to update an Eligibility Checklist for an existing protocol. \n Regulatory Setup forms initiate the regulatory setup of a new protocol in CTSU applications or to provide regulatory updates associated with an amendment.",
      requestActionBar: {
        viewHistory: "View History",
        delete: "Delete",
        cancelRequest: "Cancel Request",
        request: "Request",
        submitRequest: "Submit Request",
        viewRegulatory: "View Regulatory"
      },
      gridColumns: {
        requestNumber: {
          label: "Request"
        },
        formPartType: {
          label: "Form Type"
        },
        leadGrp: {
          label: "LPO"
        },
        protocolNumber: {
          label: "Protocol"
        },
        protocolType: {
          label: "Protocol Type"
        },
        requestTypeGroup: {
          label: "Request Type"
        },
        tentativeActivationDate: {
          label: "Tentative Activation Date"
        },
        updatedDate: {
          label: "Updated Date"
        },
        requestStatus: {
          label: "Status"
        }
      },

      newProtocolSetupForm: {
        buttonLabel: "New Protocol Setup",
        modalTitle: "New Protocol Setup Request",
        description1: "This is a \"New Protocol\" request for a protocol and form not yet in the Request Browser.",
        description2: "To make a change to an existing request in the Request Browser, navigate to the existing request and use the \"Add Request\" button to carry over existing configurations."
      },
      clearFilters: "Clear Filters"
    }
  },
  openRave: {
    infoForm: {
      requestDate: {
        label: "Date of request"
      },
      lpo: {
        label: "LPO"
      },
      protocolNumber: {
        label: "Protocol"
      },
      protocolTitle: {
        label: "Protocol title"
      },
      requestType: {
        label: "Request type"
      },
      listOfChanges: {
        label: "List of changes",
        labelHelp: "(mark all that apply)"
      },
      describeOtherChanges: {
        label: "Describe other changes"
      },
      revisionEligibilityCriteria: {
        label: "If this request is for a revision of the Eligibility Criteria (EC) then provide the revised CDE IDs",
        labelHelp: "(separate each ID with a comma)"
      },
      protocolType: {
        label: "Protocol type"
      },
      indType: {
        label: "IND type"
      },
      indAgent: {
        label: "IND agent"
      },
      indHolder: {
        label: "IND holder"
      },
      indNumber: {
        label: "IND number"
      },
      tentativeActivationDate: {
        label: "Tentative activation date"
      },
      oewgDate: {
        label: "OEWG date"
      },
      openContact: {
        label: "OPEN contact"
      },
      raveContact: {
        label: "Rave contact"
      },
      otherEmailContacts: {
        label: "Other email contact(s)",
        labelHelp: "(separate each email with a comma)"
      }
    },
    raveSetupForm: {
      isRaveProtocol: {
        label: "Is this a Rave protocol?"
      },
      raveInstanceUrl: {
        label: "Name of the Rave instance that will host this protocol",
        helperText: "Host URL: (select a Rave instance)"
      },
      isUatStudyNameAsProd: {
        label: "Same name",
        checkboxLabel: "UAT Rave study name same as PROD?"
      },
      uatRaveStudyName: {
        label: "UAT Rave study name"
      },
      openRaveAlsVersion: {
        label: "OPEN-Rave ALS version"
      },
      isRaveCtepAersInt: {
        label: "Is this a Rave-CTEP-AERS integration protocol?"
      },
      ctepAersStepNumber: {
        label: "CTEP-AERS initial step"
      },
      isTsdvSiteAuditing: {
        label: "Does this protocol use TSDV-based on-site auditing?"
      },
      isMedidataPatientCloudEpro: {
        label: "Does this protocol use Medidata Patient Cloud ePRO?"
      },
      isRequiredTriadTesting: {
        label: "Will this protocol require TRIAD testing?"
      },
      isDqpSupported: {
        label: "Will this protocol be available on the Data Quality Portal (DQP)?"
      },
      isStudyRaveCalendaring: {
        label: "Will the protocol use Rave calendaring?",
        helperText: "The standard Phase 2/3 form timeliness windows have been defined by the Data Quality Working Group as 15 days for baseline forms, 30 days for treatment forms, and 60 days for follow up forms. \r A standard for Phase 1 trials has not been established; this form will be updated with the standard Phase 1 form timeliness windows once available."
      },
      isSdpSupported: {
        label: "Does this protocol use the Source Document Portal (SDP) for central monitoring?"
      },
      cmEffectiveCheckBox: {
        label: "Use protocol activation date"
      },
      cmEffectiveDt: {
        label: "Effective date"
      },
      cmStepNumber: {
        label: "Step"
      },
      cmPatientSelectionMethod: {
        label: "Selection method"
      },
      cmFirstXPatients: {
        label: "Patient 1st X"
      },
      cmNextYPatients: {
        label: "Patient next Y"
      }
    },
    openSetupForm: {
      isStandardRandoNodeUrl: {
        label: "Does this protocol use the group's standard RandoNode URL?"
      },
      randoNodeUrl: {
        label: "RandoNode URL"
      },
      isEmbeddedAncillaryStudy: {
        label: "Is there an embedded ancillary protocol?"
      },
      protSetupAncillaryStudies: {
        sectionLabel: "Please add a row for each embedded ancillary protocol.",
        fields: {
          groupProtocolNumber: {
            label: "Group Protocol Number"
          },
          stepNumber: {
            label: "Step"
          },
          mandatory: {
            label: "Mandatory"
          }
        }
      },
      isSlotReservationProtocol: {
        label: "Is this a slot reservation protocol?"
      },
      slotReservationSteps: {
        label: "Step",
        labelHelp: "(separate each step with a comma)"
      },
      isIrocCredentialingInfoOpen: {
        label: "Will this protocol collect IROC credentialing information in OPEN?"
      },
      protSetupIrocDetails: {
        sectionLabel: "Please add a row for each type.",
        fields: {
          type: {
            label: "Type"
          },
          requirement: {
            label: "Requirement"
          }
        }
      },
      protSetupStepDetails: {
        sectionLabel: "List the step information.",
        sectionDescription: "Complete the step information per row. Use +Step button to add additional rows.",
        fields: {
          required: {
            label: "Required"
          },
          publicFormIds: {
            label: "Public Form ID(s)"
          },
          crfVersionNum: {
            label: "CRF Version"
          },
          stepNumber: {
            label: "Step"
          },
          stepDescription: {
            label: "Step Description"
          },
          registrationType: {
            label: "Registration Type"
          },
          initialization: {
            label: "Patient Initialization"
          },
          transferEcData: {
            label: "Transfer EC Data"
          },
          markForDownload: {
            label: "Mark for Download"
          },
          regTypeTooltip:
            "i. Patient forms enroll patient participants. \nii. Non-Patient Providers forms enroll physicians, physician assistants, and nurse practitioners. \niii. Non-Patient Other Professional Discipline forms enroll other professionals involved with the care of patients. \niv. Non-Patient Caregiver forms enroll family and other non-medical professionals involved with patient care. \nv. Non-Patient Practices forms enroll the sites enrolling non-patients. \nvi. Non-Patient Other forms enroll all other non-patient entities not defined in other existing form types."
        }
      },
      requestedTestSites: {
        label: "Requested test sites",
        labelHelp: "(separate each site with a comma)"
      },
      additionalSetupNotes: {
        label: "Additional setup notes"
      }
    },
    openRaveSubmitForm: {
      primaryOpenAdmin: {
        label: "CTSU User"
      },
      primaryComments: {
        label: "Comments"
      },
      secondaryOpenAdmin: {
        label: "CTSU User"
      },
      secondaryComments: {
        label: "Comments"
      }
    },
    uatSetupForm: {
      isOpenAdminSetupCompleted: {
        label: "OPEN Admin has completed UAT setup."
      },
      formIdsList: {
        label: "List of form IDs downloaded in UAT",
        labelHelp: "(separate each ID with a comma)"
      },
      testSitesList: {
        label: "Test site(s)",
        labelHelp: "(separate each site with a comma)"
      }
    },
    ctsuTestingForm: {
      isCTSUCompletedTesting: {
        label: "CTSU has completed their testing and is ready for sign off."
      },
      comments: {
        label: "Comments"
      },
      files: {
        label: "Attachments",
        labelHelp: "(attachments should be redacted, remove PII)"
      }
    },
    groupTestingForm: {
      isGroupCompletedTesting: {
        label: "Group has completed their testing and provides approval for the OPEN team to proceed with testing."
      },
      comments: {
        label: "Comments"
      },
      files: {
        label: "Attachments",
        labelHelp: "(attachments should be redacted, remove PII)"
      }
    },
    pendingSignOffForm: {
      releaseDateTime: {
        label: "Release Date & Time",
        labelHelp: "(Eastern time)"
      },
      groupAdminSignOff: {
        label: "Group Admin signs off that form(s) are ready for production."
      },
      groupAdminComments: {
        label: "Comments"
      },
      openAdminSignOff: {
        label: "OPEN Admin signs off that form(s) are ready for production."
      },
      openAdminComments: {
        label: "Comments"
      },
      irocAdminSignOff: {
        label: "IROC Admin signs off that testing is completed and ready for production."
      },
      irocAdminComments: {
        label: "Comments"
      }
    },
    completedForm: {
      setupCompletedProd: {
        label: "Setup has been completed in production."
      },
      formsActivatedProd: {
        label: "Form(s) are activated in production."
      },
      comments: {
        label: "Comments"
      },
      files: {
        label: "Attachments",
        labelHelp: "(attachments should be redacted, remove PII)"
      },
      groupTitle: {
        label: "Optional Tracking Data"
      },
      submitSuccess: {
        message: "Complete signoff form successfully submitted."
      },
      fileFormatError: {
        message: "Only .doc, .pdf, .msg, .xlsx files are allowed"
      },
      maxCharError: {
        message: "Cannot exceed 1000 characters."
      },
      saveButton: {
        label: "Save"
      }
    }
  },
  regulatory: {
    common: {
      successUpdate: {
        message: "Record successfully updated."
      },
      successCreate: {
        message: "Record successfully created."
      },
      errorDefault: {
        message: "Unable to complete the request. Contact CTSU Help Desk, ctsucontact@westat.com."
      }
    },
    index: {
      pageTitle: "Protocol Setup Request",
      newRequestTitle: "New Protocol Setup Request",
      description: "Regulatory Setup forms initiate the regulatory setup of a new protocol in CTSU applications to provide regulatory updates associated with an amendment.",
      descriptionNote: "All required fields must be completed to save each page.",
      tabs: {
        info: "Protocol Information",
        setup: "Regulatory Setup"
      }
    },
    infoForm: {
      title: "Regulatory Setup",
      layoutTitle: "Protocol Setup",
      requestDate: {
        label: "Date of request"
      },
      lpo: {
        label: "LPO"
      },
      protocolNumber: {
        label: "Protocol"
      },
      protocolTitle: {
        label: "Protocol title"
      },
      requestType: {
        label: "Request type"
      },
      primaryContact: {
        label: "Primary contact"
      }
    },
    regulatorySetupForm: {
      protocolVersionDt: {
        label: "Protocol version date"
      },
      protocolVersionNumber: {
        label: "Protocol version",
        labelHelp: "(description)"
      },
      levelIrbReviewRequired: {
        label: "Level of IRB review required"
      },
      ohrpCategory: {
        label: "OHRP categories",
        labelHelp: "(detailed descriptions of category values can be found in the help topics on this screen.)"
      },
      whenExpeditedReviewAllowed: {
        label: "When is expedited review allowed?"
      },
      releaseDt: {
        label: "Release date & time"
      },
      ctsuCollectionRequired: {
        label: "CTSU collection required"
      },
      anticipatedPrimaryCompletionDt: {
        label: "Anticipated Primary Completion Date (APCD)"
      },
      isCollectIrbApprovalPostClosure: {
        label: "Collect IRB approval post-closure"
      },
      countries: {
        label: "Participating countries"
      },
      isCtaRequired: {
        label: "CTA required",
        checkboxLabel: "Is a CTA required, and who holds?"
      },
      ctaRequiredInfo: {
        label: "CTA holder"
      },
      participationChangeDesc: {
        label: "Complete if there is a change from the previous protocol cover page. Description of participation change(s)"
      },
      indAgent: {
        label: "IND agent"
      },
      indHolder: {
        label: "IND holder"
      },
      indNumber: {
        label: "IND number"
      },
      attachPSR: {
        label: "Attach PSR examples",
        labelHelp: "(attachments should be redacted, remove PII)"
      }
    },
    psrForm: {
      psrName: {
        label: "Name",
        labelHelp: "(description)"
      },
      psrVersionDt: {
        label: "For Version Date"
      },
      psrType: {
        label: "PSR Type"
      },
      psrRequiredByDt: {
        label: "Required By Date"
      },
      psrNumOfPersons: {
        label: "Persons",
        labelHelp: "(for person attributes)"
      },
      isEvaluationByGroup: {
        label: "Evaluation by Group"
      },
      requestedStatus: {
        label: "Requested Status"
      },
      sourceSubmittedBy: {
        label: "Source",
        labelHelp: "(submitted by)"
      },
      ctsuProcessingInstructions: {
        label: "CTSU Processing Instructions"
      },
      psrComments: {
        label: "Comments"
      },
      psrContactName: {
        label: "Name"
      },
      psrContactPhoneNum: {
        label: "Phone"
      },
      psrContactEmailAddress: {
        label: "Email"
      },
      psrDistributionList: {
        label: "Distribution List",
        labelHelp: "(list additional email addresses that should receive email notifications)"
      },
      createdBy: {
        label: "Created By"
      },
      createdDt: {
        label: "Created Date"
      },
      modifiedBy: {
        label: "Modified By"
      },
      modifiedDt: {
        label: "Modified Date"
      },
      selectorLabel: "Select existing PSR for changes (Key: Name/description (For Version Date | PSR Type))",
      changeSelectedPsrBtn: "Change selected PSR",
      processingInstructionsTitle: "CTSU Processing Instructions",
      contactInfoTitle: "Contact Information",
      auditHistoryTitle: "Audit History",
      buttons: {
        edit: "Edit",
        save: "Save",
        cancel: "Cancel"
      }
    },
    psrTable: {
      tableTitle: "PSR Requirement(s)",
      subtitle: "Each row should represent a PSR with at least one change. All changes to PSRs are a request and do not affect the current PSR until the entire request is completed.",
      deleteModal: {
        title: "Remove PSR from Request",
        message1: "Please confirm you would like to remove",
        message2: "from this request. Doing so will lose all changes associated to that PSR.",
        message3: "If you would like to continue editing this PSR, please Cancel.",
        confirmBtn: "Confirm",
        cancelBtn: "Cancel",
        deleteTitle: "Remove PSR from request"
      },
      notification: {
        updated: "PSR updated",
        deleted: "PSR deleted",
        added: "PSR added"
      },
      columns: {
        psrName: {
          label: "Name (description)"
        },
        psrType: {
          label: "PSR Type"
        },
        psrNumOfPersons: {
          label: "Number of Persons"
        },
        isEvaluationByGroup: {
          label: "Evaluation by Group",
          options: {
            yes: "Yes",
            no: "No"
          }
        },
        sourceSubmittedBy: {
          label: "Source (submitted by)"
        },
        ctsuProcessingInstructions: {
          label: "CTSU Processing Instructions"
        },
        requestedStatus: {
          label: "Requested Status"
        },
        modifiedDate: {
          label: "Modified Date"
        },
        actions: {
          label: "Actions"
        }
      }
    },
    psrModal: {
      selectUpdateType: "Select the type of PSR update for this request.",
      buttons: {
        changeExisting: {
          label: "Change to existing PSR",
          title: "Makes change(s) to an existing PSR"
        },
        newPsr: {
          label: "New PSR",
          title: "New PSR"
        },
        addPsr: {
          label: "PSR",
          title: "Add PSR"
        },
        cancel: "Cancel"
      },
      titles: {
        addPsr: "Add PSR",
        newPsr: "New PSR",
        changeExisting: "Change to Existing PSR"
      }
    },
    regulatoryAdditionalSignOff: {
      irocAdminSignoff: {
        label: "I acknowledge that the RT requirements included in this setup request match the RT credentialing approvals that IROC will be issuing for this study."
      },
      irocAdminComments: {
        label: "Comments"
      }
    },
    regulatoryInProgress: {
      regReviewCompletedYn: {
        label: "The Regulatory Admin(s) have completed review."
      },
      regComments: {
        label: "Comments"
      },
      files: {
        label: "Attachments",
        labelHelp: "(attachments should be redacted, remove PII)"
      },
      isRegAckCompletedYn: {
        label: "I acknowledge the CTSU Regulatory Office has completed this request."
      }
    },
    regulatorySubmitForm: {
      groupAdminSignoff: {
        label: "I acknowledge that the information provided in this protocol setup request is accurate to be the best of my knowledge and that I have reached out to the CTSU Regulatory Office at CTSURegSetup@coccg.org with any questions, as applicable, prior to generating this submission."
      },
      groupAdminComments: {
        label: "Comments"
      },
      irocAdminSignoffRequired: {
        label: "This request will require IROC sign off."
      }
    },
    signOff: {
      submitForm: {
        warning: "Warning - There is either a submitted OPEN/Rave Protocol Setup request that has not completed CTSU Testing, or an OPEN/Rave Protocol Setup request does not exist for this protocol. Please check with the CTSU OPEN team ctsuopenforms@westat.com in order to proceed with the Regulatory Protocol Setup request."
      },
      inProgress: {
        successMessage: "Pending signoff form successfully submitted."
      },
      additional: {
        reminderSuccess: "Reminder sent successfully.",
        sectionTitle: "IROC Admin"
      }
    }
  }
};

export default labelsAndHelpText;
